<template>
  <div class="menu tab_action tab_bg">
    <div class="backtop">
      <span class="btncenter">设置</span>
      <div @click="close" class="chatbox_close">
        <i class="iconfont icon-guanbi"></i>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li @click="tab = 0" :class="{ check: tab == 0 }">面捕采集</li>
        <li
          @click="tab = 1"
          v-if="false"
          v-show="user.type == 2"
          :class="{ check: tab == 1 }"
        >
          参数绑定
        </li>
        <li v-if="false" @click="tab = 2" :class="{ check: tab == 2 }">
          快捷键
        </li>
      </ul>

      <TabFace
        v-if="tab == 0"
        :modelClass="modelClass"
        :user="user"
        :carmeraList="carmeraList"
        :face2ctoo="face2ctoo"
        @videoSelect="videoSelect"
        :userconfig="userconfig"
        @setconfig="setconfig"
        ref="tabFace"
      ></TabFace>
      <TabParam
        v-if="tab == 1"
        :modelClass="modelClass"
        :user="user"
        :v2cobj="v2cobj"
        :v2cOutParam="v2cOutParam"
        ref="tabParam"
        :defaultParam="defaultParam"
      ></TabParam>
      <TabKeys
        v-if="tab == 2"
        :modelClass="modelClass"
        :user="user"
        ref="tabKeys"
        @success="setKeysSuccess"
      ></TabKeys>
    </div>
  </div>
</template>

<script>

import TabKeys from '../operate/TabKeys.vue'
import TabFace from '../operate/TabFace.vue'
import TabParam from '../operate/TabParam.vue'
import { localData } from '@/components/util/util_fun.js'

export default {
  name: 'Set',
  props: ['modelClass', 'face2ctoo', 'v2cobj', 'v2cOutParam', 'defaultParam', 'userconfig'],
  components: {
    TabKeys, TabFace, TabParam
  },
  data () {
    return {
      tab: 0,
      carmeraList: [],//摄像头列表
      user: null,// 当前角色信息

    }
  },
  created () {

    this.user = localData("get", "historyHodel_" + this.$store.state.userinfo.userId)






  },
  mounted () {

  },
  methods: {
    close () { //关闭设置弹窗
      this.$emit('update:visible', false)
    },
    checkTab () {
      this.tab = 0
    },
    EditBack () {
      this.$emit("close")
    },

    /**
     * 用户更新保存用户习惯
     */
    setconfig (name, newValue) {
      this.$emit("setconfig", name, newValue)
    },
    //摄像头切换事件
    videoSelect (camera) {
      this.$emit("videoSelect", camera)
    },

    //窗口程序获取到的摄像头列表
    videoList (list) {
      this.carmeraList = list
      if (this.tab == 0) {
        this.$refs.tabFace.videoListChange(list)
      }
    },
    /****************************快捷键设置*************************** */

    //保存热键后的回调
    setKeysSuccess (param) {
      // this.bindKey(param);
      this.$emit("success", param)
    },

    //热键绑定
    bindKey (param) {

      if (param == undefined) {
        if (this.user.param != "" && this.user.param != undefined && this.user.param != null && this.user.param.length > 0) {
          param = JSON.parse(this.user.param)
        } else {
          return
        }
      }
      if (param.systemKey == undefined) {
        param.systemKey = []
      }
      if (param.action == undefined) {
        param.action = []
      }
      //销毁之前的快捷键
      this.destroyKey()

      if (param.action.length <= 0 && param.systemKey.length <= 0) {
        return
      }

      var keyList = []
      var that = this

      var actionList = param.action
      var systemKey = param.systemKey

      //这是动作
      for (var a = 0; a < actionList.length; a++) {
        for (var b = 0; b < actionList[a].Shortcutkey.length; b++) {
          //text文本，controlKey用来比对的控制键，key对应的动作，type:1系统快捷键2动作按键
          keyList.push({ text: actionList[a].Shortcutkey[b].text, controlKey: actionList[a].Shortcutkey[b].controlKey, key: actionList[a].key, type: 2 })
        }
      }

      //这里是系统按键
      for (var a = 0; a < systemKey.length; a++) {
        for (var b = 0; b < systemKey[a].Shortcutkey.length; b++) {
          keyList.push({ text: systemKey[a].Shortcutkey[b].text, controlKey: systemKey[a].Shortcutkey[b].controlKey, key: systemKey[a].key, type: 1 })
        }
      }



      //窗口模式
      if (this.windowParam.isWindows) {

        this.sendMsg(101, "注册全局快捷键", keyList)

      } else {

        for (var a = 0; a < keyList.length; a++) {

          var that = this
          this.$shortcut.bind(keyList[a].text.toLocaleLowerCase(), function (key) {

            that.keyList.forEach(function (object, index) {
              if (key.code == object.controlKey.code
                && key.altKey == object.controlKey.altKey
                && key.key == object.controlKey.key
                && key.shiftKey == object.controlKey.shiftKey
              ) {
                that.playKeyEvent(object)
              }
            })
          })
        }

      }

      this.keyList = keyList
      // console.log(keyList)
    },

    //销毁快捷键key
    destroyKey () {
      // console.log("销毁所有快捷键")
      //窗口模式
      if (this.windowParam.isWindows) {

        this.sendMsg(102, "销毁全局快捷键")

      } else {
        var that = this
        this.keyList.forEach(function (keyObj, index) {
          that.$shortcut.unbind(keyObj.text.toLocaleLowerCase())
        })
      }

    },

    //监听快捷键执行动画
    playKeyEvent (object) {

      if (object.type == 1) {
        console.log("系统按键：" + object.key)
        //菜单隐藏
        if (object.key == "showOrHideMenu") {
          this.beginLive()

          //面捕打开或关闭
        } else if (object.key == "openOrCloseFace") {

          if (this.v2cParam.videoOpen) {
            this.closeVideo()
          } else {
            this.videoOpenClose()
          }

        }
      } else {
        console.log("快捷键播放动画：" + object.key)
        this.playModelAnimation(object.key)
      }


    },

    //播放动画的方法
    playModelAnimation (actionKey) {
      modelClass.playAnimation(actionKey, 1)
    },
  },


}
</script>
<style lang="scss" scoped>
.menu {
  position: absolute;
  top: -64px;
  top: 0;
  width: 100%;
  left: 0;

  height: calc(100% + 64px);
  // background: #fff;
  .varbox {
    padding: 20px 0;
    line-height: 1.5em;
    // padding-left: 0;
    border-radius: 20px;
    div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      line-height: 30px;
    }
    .pink {
      color: #f4acb7;
      margin: 0 5px;
    }
    .iconfont {
      margin-bottom: 0;
      margin-right: 4px;
      font-size: 20px !important;
    }
    .icon-cuowu {
      color: #ee012e;
    }
    .icon-zhengque {
      color: #01a411;
    }
  }
  // .content-box {
  //     margin: 0!important;
  // }
}

.tab_active {
  border: 3px solid #f4acb7;
  box-sizing: border-box;
}
.chatbox_close {
  position: absolute;
  z-index: 10;
  right: 0;
  top: 0;
  cursor: pointer;
  i {
    font-size: 26px !important;
  }
  &:hover i {
    color: #39f;
  }
}
</style>